module.exports = __webpack_public_path__ + "images/shimo/mindmap-list-612beed1512d0d7ea961e1fae1c563b2.png";